import { FC } from "react";
import { observer } from "mobx-react-lite";
import { Layout, ITabs } from "../../ui-kit";
import { ITab } from "../../ui-kit/Tabs/Tabs";

import SmsIncidentParams from "./SmsIncidentParams";
import SmsSettingsDistribution from "./SmsSettingsDistribution";
import SmsSettingsTemplates from "./SmsSettingsTemplates";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import Paths from "../../constants/PathsBreadcrumbs";

const SmsSettings: FC = observer(() => {
  useBreadcrumbs(Paths.spNotifSettings);

  const initialTabs: Array<ITab> = [
    {
      name: "Настройка параметров инцидента",
      key: "params",
      content: <SmsIncidentParams />,
    },
    {
      name: "Настройка списка рассылки",
      key: "distribution",
      content: <SmsSettingsDistribution />,
    },
    {
      name: "Настройка текста",
      key: "text",
      content: <SmsSettingsTemplates />,
    },
  ];

  return (
    <Layout>
      <ITabs tabs={initialTabs}></ITabs>
    </Layout>
  );
});

export default SmsSettings;
